import { ActivityEntityName, MetadataEntityFieldData } from '@jms/model';
import { booleanFormat, type BooleanCellRendererFormat } from '@workbuddy/ui/cell.renderers';
import type { FilterOption } from '@workbuddy/ui/v2/blocks/filter';

/**
 * The list column for Job Template `public` is Visibility (Public/Private). The filter
 * must use the same pair — a generic boolean would show Yes/No against Public/Private cells.
 */
export function booleanFilterFormat(entity: ActivityEntityName | null | undefined, field: Pick<MetadataEntityFieldData, 'name' | 'path'>): BooleanCellRendererFormat {

  const key = field.path ?? field.name;
  if (entity === ActivityEntityName.JobTemplate && key === 'public') return 'Public/Private';
  return 'Yes/No';
}

export function booleanFilterOptions(format: BooleanCellRendererFormat): FilterOption<boolean>[] {

  return [
    { id: 'true', label: booleanFormat(true, format), data: true },
    { id: 'false', label: booleanFormat(false, format), data: false },
  ];
}

export function booleanFilterValueLabel(value: unknown, format: BooleanCellRendererFormat): string | null {

  const raw = Array.isArray(value) ? value[0] : value;
  if (raw == null) return null;
  return booleanFormat(raw === true || raw === 'true', format);
}
